import { Component, ChangeDetectionStrategy, HostBinding } from "@angular/core";

@Component({
    selector: "sps-content-row-expansion",
    templateUrl: "./sps-content-row-expansion.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpsContentRowExpansionComponent {
    @HostBinding("class.sps-content-row__expansion") readonly _spsContentRowExpansionClass = true;
}
